var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-tip"},[_c('svg-icon',{staticStyle:{"color":"#266EFF","font-size":"16px"},attrs:{"name":"common.tip-solid"}}),(_vm.$slots.default)?_vm._t("default"):[_vm._v(" "+_vm._s(_vm.text)+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }